const traderOrigin = process.env.NEXT_PUBLIC_TRADER_ORIGIN;
export const traderAuthLoginUrl = `${traderOrigin}/api/v1/bff/initiate-oidc-signin`;
export const traderAuthLogoutUrl = `${traderOrigin}/api/v1/bff/logout`;

export const getTraderAuthCallbackUrl = (
  traderRoute: string,
  isLoggedIn: boolean
) => {
  const redirectUrl = `${traderOrigin}${traderRoute}?__embeddedInIframe=true`;
  return isLoggedIn
    ? `${traderAuthLoginUrl}?redirectUrl=${encodeURIComponent(redirectUrl)}`
    : redirectUrl;
};

export const getTraderUrl = (traderRoute: string) => {
  const url = new URL(traderRoute, traderOrigin);
  url.searchParams.set('__embeddedInIframe', 'true');
  return url.toString();
};
